import { FC, forwardRef, Ref } from 'react';
import { IconName, Size } from '@optimus-web/core';
import { HighlightIconElement } from './style';
import { HighlightIconVariant } from './types';

interface HighlightIconProps {
    icon: IconName;
    variant?: HighlightIconVariant;
    forwardedRef?: Ref<HTMLSpanElement>;
    size?: Exclude<Size, 'large' | 'extraLarge'>;
}

export const HighlightIconComponent: FC<HighlightIconProps> = ({
    icon,
    size = 'medium',
    variant = 'basic',
    forwardedRef,
}: HighlightIconProps) => (
    <HighlightIconElement ref={forwardedRef} value={icon} backgroundVariant={variant} size={size} />
);

export const HighlightIcon = forwardRef<HTMLSpanElement, HighlightIconProps>((props, ref) => (
    <HighlightIconComponent {...props} forwardedRef={ref} />
));
